import FeatureTeaser from "./feature-teaser";

export default FeatureTeaser;
